var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"theme4-contact"},[_c('theme4-contact-component'),_c('theme-changer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }